import './_visibility-manager.sass';

import $ from 'jquery';

import Class from './legacy-class';

export default Class({
    init(element) {
        this.element = element;
        this.element.addClass('ui-visibility-managed');
        this._visibility_triggers = this.element
            .find('[show-depends]')
            .map((i, el) => $(el).attr('show-depends').split(' '))
            .get();
        this._visibility_triggers.push('capabilities', 'access');
        this._visibility_triggers = this._unique(this._visibility_triggers);

        this._update_visibility_bound = () => this._update_visibility();
    },

    _unique(arr) {
        const set = {};
        for (const i of arr) set[i] = true;
        return Object.keys(set);
    },

    _update_visibility() {
        this.element.find('[required-caps]').each((i, el) => {
            const or_rules = $(el).attr('required-caps').split(' ');
            let ok = true;
            for (const or_rule of or_rules) {
                const caps = or_rule.split('|');
                if (!this._device?.has_any_capability(caps)) {
                    ok = false;
                    break;
                }
            }
            $(el).toggleClass('caps-matched', ok);
        });

        this.element.find('[required-access]').each((i, el) => {
            $(el).toggleClass(
                'access-matched',
                this._device?.has_access($(el).attr('required-access'))
            );
        });

        this.element.find('[show-if]').each((i, el) => {
            const predicate = new Function(
                'device',
                'context',
                'return !!(' + $(el).attr('show-if') + ')'
            );
            $(el).toggleClass(
                'show-matched',
                this._device != null ? predicate(this._device, this._context) : false
            );
        });
    },
}).implement(
    Class.Properties({
        device: {
            set(device) {
                this._device = device;

                if (this._device_bindings)
                    for (const binding of this._device_bindings) binding.unbind();

                this._device_bindings = null;
                if (this._device) {
                    this._device_bindings = this._visibility_triggers.map((vis_prop) =>
                        this._device.bind(vis_prop, this._update_visibility_bound)
                    );
                }

                this._update_visibility();
            },
        },

        context: {
            value: null,
            set(context) {
                this._context = context;
                this._update_visibility();
            },
        },
    })
);
